import { render } from "./JournalsComponent.vue?vue&type=template&id=12f6c3ab&scoped=true"
import script from "./JournalsComponent.vue?vue&type=script&lang=js"
export * from "./JournalsComponent.vue?vue&type=script&lang=js"

import "./JournalsComponent.vue?vue&type=style&index=0&id=12f6c3ab&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f6c3ab"]])

export default __exports__